import React from "react";

// Pre-composed assets (chip backdrop + mammoth baked together).
// Black background was stripped to true transparency server-side, so they
// drop cleanly onto any page color.
const ASSETS = {
  circle: {
    src: "/mammoth-circle.png",
    // image height vs. chip's visual size (1.0 = image height matches `size`)
    heightFactor: 1.05,
  },
  rounded: {
    src: "/mammoth-light.png",
    heightFactor: 1.18,
  },
};

// Normalize `size` to a CSS length string (accepts numbers as px, or any CSS
// value such as "clamp(...)", "min(...)", "20vw", "100%", etc.)
const cssLen = (v) => (typeof v === "number" ? `${v}px` : v);

/**
 * The Mammoth Coach mascot.
 * Renders the pre-composed PNG (#9bd5d7 chip + lattice mammoth posed with
 * arms / legs / tusks spilling outside the chip's border).
 *
 * RESPONSIVE: pass `size` as either a number (fixed px) or a CSS string for
 * fluid scaling — e.g. `"clamp(140px, 22vw, 280px)"`, `"min(40vw, 360px)"`,
 * `"100%"`. The internal image uses relative sizing so it tracks the wrapper
 * on any device. No JS resize listeners, no rerenders — pure CSS.
 *
 * Props:
 *  - size: number (px) | string (CSS length) — chip layout footprint
 *  - shape: "circle" | "rounded"
 *  - className: forwarded to wrapper
 */
export const MammothMascot = ({
  size = 220,
  shape = "rounded",
  className = "",
  // legacy props ignored:
  tone, stage, overflow, float,
}) => {
  const asset = ASSETS[shape] || ASSETS.rounded;
  const w = cssLen(size);

  return (
    <div
      data-testid="mammoth-mascot"
      className={className}
      style={{
        position: "relative",
        width: w,
        height: w,
        // Keep a stable square layout footprint across breakpoints.
        aspectRatio: "1 / 1",
        overflow: "visible",
        // Drop-shadow on the wrapper traces the actual mammoth + chip
        // silhouette (PNG has transparent surround).
        filter:
          shape === "circle"
            ? "drop-shadow(0 10px 22px rgba(0,0,0,0.12))"
            : "drop-shadow(0 24px 50px rgba(0,0,0,0.14)) drop-shadow(0 8px 18px rgba(0,0,0,0.06))",
      }}
    >
      <img
        src={asset.src}
        alt="Mammoth coach"
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          // height is relative to wrapper -> scales with every breakpoint.
          height: `${Math.round(asset.heightFactor * 100)}%`,
          width: "auto",
          maxWidth: "none",
          userSelect: "none",
          pointerEvents: "none",
          display: "block",
        }}
        draggable={false}
      />
    </div>
  );
};

export default MammothMascot;
